// 菜单与按钮权限资源（方案A：前端常量维护，角色管理从这里勾选）
// code 约定：模块:资源:操作；菜单 code 为 模块:资源

const MENU_RESOURCE = [
    {
        code: 'serial',
        label: '串码管理',
        children: [
            {
                code: 'serial:list',
                label: '串码池',
                path: '/serial/list',
                buttons: [
                    { code: 'serial:import', label: '导入串码' },
                    { code: 'serial:import-old', label: '导入旧平台串码' },
                    { code: 'serial:export', label: '导出' },
                    { code: 'serial:detail', label: '详情' },
                    { code: 'serial:unbind', label: '解绑CPUID' },
                    { code: 'serial:reset', label: '重置授权' },
                    { code: 'serial:void', label: '作废' },
                ],
            },
            {
                code: 'serial:import-records',
                label: '导入记录',
                path: '/serial/import-records',
                buttons: [
                    { code: 'serial:import:download', label: '下载' },
                    { code: 'serial:import:fail-detail', label: '失败详情' },
                ],
            },
            { code: 'serial:void-records', label: '作废记录', path: '/serial/void-records' },
            { code: 'serial:reset-records', label: '重置记录', path: '/serial/reset-records' },
            { code: 'serial:unbind-records', label: '解绑记录', path: '/serial/unbind-records' },
            {
                code: 'serial:shipment',
                label: '发货报盘',
                path: '/serial/shipment',
                buttons: [
                    { code: 'serial:shipment:declare', label: '发货报盘' },
                ],
            },
            {
                code: 'serial:return',
                label: '退货管理',
                path: '/serial/return',
                buttons: [
                    { code: 'serial:return:declare', label: '退货' },
                ],
            },
        ],
    },
    {
        code: 'order',
        label: '生产工单',
        children: [
            {
                code: 'order:list',
                label: '工单管理',
                path: '/order/list',
                buttons: [
                    { code: 'order:create', label: '创建工单' },
                    { code: 'order:edit', label: '编辑' },
                    { code: 'order:serial', label: '查看串码' },
                    { code: 'order:export', label: '导出' },
                    { code: 'order:close', label: '关闭' },
                ],
            },
            { code: 'auth:alerts', label: '异常告警', path: '/auth/alerts' },
        ],
    },
    {
        code: 'config',
        label: '基础配置',
        children: [
            {
                code: 'config:platform',
                label: '运营平台配置',
                path: '/config/platforms',
                buttons: [
                    { code: 'config:platform:add', label: '新增平台' },
                    { code: 'config:platform:edit', label: '编辑平台' },
                    { code: 'config:model:add', label: '新增型号' },
                    { code: 'config:model:edit', label: '编辑型号' },
                    { code: 'config:model:toggle', label: '启停型号' },
                ],
            },
            {
                code: 'config:mac-rule',
                label: 'MAC规则配置',
                path: '/config/mac-rule',
                buttons: [{ code: 'config:mac-rule:save', label: '保存' }],
            },
            {
                code: 'config:factory',
                label: '工厂管理',
                path: '/config/factories',
                buttons: [
                    { code: 'config:factory:add', label: '新增工厂' },
                    { code: 'config:factory:edit', label: '编辑' },
                    { code: 'config:factory:batch', label: '串码分批' },
                ],
            },
            {
                code: 'config:notify',
                label: '邮箱告警通知',
                path: '/config/notify',
                buttons: [
                    { code: 'config:notify:edit', label: '编辑' },
                    { code: 'config:notify:save', label: '保存' },
                    { code: 'config:notify:test', label: '测试发送' },
                ],
            },
        ],
    },
    {
        code: 'system',
        label: '系统管理',
        children: [
            {
                code: 'system:account',
                label: '账户管理',
                path: '/system/accounts',
                buttons: [
                    { code: 'system:account:add', label: '新增账户' },
                    { code: 'system:account:edit', label: '编辑' },
                    { code: 'system:account:assign', label: '权限分配' },
                ],
            },
            {
                code: 'system:role',
                label: '角色管理',
                path: '/system/roles',
                buttons: [
                    { code: 'system:role:add', label: '新增角色' },
                    { code: 'system:role:edit', label: '编辑' },
                    { code: 'system:role:delete', label: '删除' },
                ],
            },
        ],
    },
];

// 收集所有权限 code（含菜单与按钮），用于管理员「全部权限」
export const ALL_CODES = (() => {
    const codes = [];
    MENU_RESOURCE.forEach((g) => g.children.forEach((m) => {
        codes.push(m.code);
        (m.buttons || []).forEach((b) => codes.push(b.code));
    }));
    return codes;
})();

// 路由 path -> 菜单 code，用于菜单过滤与路由守卫
export const MENU_PATH_CODE_MAP = (() => {
    const map = {};
    MENU_RESOURCE.forEach((g) => g.children.forEach((m) => {
        if (m.path) map[m.path] = m.code;
    }));
    return map;
})();

export default MENU_RESOURCE;
